import { c as _c } from "react/compiler-runtime";
import { LoadingButton } from '@7f-ui/components/button/loading-button';
import { shopTestId } from '@utils/utils-shop-test-ids';
import { useRef } from 'react';
import type { Control } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import type { ActiveField } from '../model/use-search-field';
import type { SearchResult } from '../src/lib/use-geo-search';
import { DateRangeField, focusDateField, validateDateRange } from './date-range-field';
import { LocationField } from './location-field';
import type { FormValues } from './search-field';
type FieldsProps = {
  activeField: ActiveField;
  control: Control<FormValues>;
  min: Date;
  max: Date;
  isNavigating: boolean;
  onChange: (value: SearchResult | null) => void;
  onInputChange: (value: string) => void;
  onLabelClick: (field: ActiveField) => void;
  onFocus: (field?: ActiveField) => void;
  onReset: (field: ActiveField) => void;
};
export function Fields(t0) {
  const $ = _c(35);
  const {
    activeField,
    control,
    min,
    max,
    isNavigating,
    onChange: onLocationChange,
    onInputChange,
    onLabelClick,
    onFocus,
    onReset
  } = t0;
  const isUpdatingLocation = useRef(false);
  const t1 = activeField ?? "default";
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      required: "Bitte gib einen Ort ein."
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== activeField || $[2] !== onFocus || $[3] !== onInputChange || $[4] !== onLabelClick || $[5] !== onLocationChange || $[6] !== onReset) {
    t3 = t4 => {
      const {
        field: t5,
        fieldState
      } = t4;
      const {
        ref,
        value,
        onChange,
        ...field
      } = t5;
      return <LocationField ref={ref} inputProps={{
        ...field,
        placeholder: "Orte, St\xE4dte, Regionen"
      }} value={value} label="Wohin reist du?" error={fieldState.error?.message} onChange={selectedLocation => {
        onChange(selectedLocation);
        onLocationChange(selectedLocation);
        isUpdatingLocation.current = true;
      }} onFocus={() => {
        if (isUpdatingLocation.current) {
          isUpdatingLocation.current = false;
          setTimeout(focusDateField, 0);
          return;
        }
        onFocus("location");
      }} onReset={() => onReset("location")} onLabelClick={() => onLabelClick("location")} onInputChange={onInputChange} isActive={activeField === "location"} />;
    };
    $[1] = activeField;
    $[2] = onFocus;
    $[3] = onInputChange;
    $[4] = onLabelClick;
    $[5] = onLocationChange;
    $[6] = onReset;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== control || $[9] !== t3) {
    t4 = <Controller name="location" control={control} rules={t2} render={t3} />;
    $[8] = control;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== max || $[12] !== min) {
    t5 = {
      validate: value_0 => validateDateRange(value_0, {
        start: min,
        end: max
      })
    };
    $[11] = max;
    $[12] = min;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== activeField || $[15] !== max || $[16] !== min || $[17] !== onFocus || $[18] !== onLabelClick) {
    t6 = t7 => {
      const {
        field: t8,
        fieldState: t9
      } = t7;
      const {
        ref: _ref,
        ...field_0
      } = t8;
      const {
        invalid
      } = t9;
      return <DateRangeField {...field_0} min={min} max={max} error={invalid} label="Wann verreist du?" onLabelClick={() => onLabelClick("dates")} onFocus={() => {
        if (isUpdatingLocation.current) {
          setTimeout(() => {
            isUpdatingLocation.current = false;
          }, 0);
        }
        onFocus("dates");
      }} isActive={activeField === "dates"} />;
    };
    $[14] = activeField;
    $[15] = max;
    $[16] = min;
    $[17] = onFocus;
    $[18] = onLabelClick;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== control || $[21] !== t5 || $[22] !== t6) {
    t7 = <Controller name="dates" control={control} rules={t5} render={t6} />;
    $[20] = control;
    $[21] = t5;
    $[22] = t6;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  let t8;
  if ($[24] !== t1 || $[25] !== t4 || $[26] !== t7) {
    t8 = <div className="search-field-inputs pl-2 text-primary" data-focus={t1}>{t4}{t7}</div>;
    $[24] = t1;
    $[25] = t4;
    $[26] = t7;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  let t9;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      root: "ml-auto"
    };
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  let t10;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = shopTestId("Search.submit");
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  let t11;
  if ($[30] !== isNavigating) {
    t11 = <div className="pr-2"><LoadingButton isLoading={isNavigating} classNames={t9} type="submit" size="medium" data-testid={t10}>Suchen</LoadingButton></div>;
    $[30] = isNavigating;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  let t12;
  if ($[32] !== t11 || $[33] !== t8) {
    t12 = <div className="flex flex-1 items-center gap-4">{t8}{t11}</div>;
    $[32] = t11;
    $[33] = t8;
    $[34] = t12;
  } else {
    t12 = $[34];
  }
  return t12;
}